export default __webpack_public_path__ + "static/media/web.c3ea6832.ogg";